"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.add = add;
exports.default = void 0;
exports.del = del;
exports.edit = edit;
exports.get = get;
exports.getReportData = getReportData;
exports.updateByHeader = updateByHeader;

var _request = _interopRequireDefault(require("@/utils/request"));

function add(data) {
  return (0, _request.default)({
    url: 'api/CmsGenerateReport',
    method: 'post',
    data: data
  });
}

function del(ids) {
  return (0, _request.default)({
    url: 'api/CmsGenerateReport',
    method: 'delete',
    data: ids
  });
}

function edit(data) {
  return (0, _request.default)({
    url: 'api/CmsGenerateReport',
    method: 'put',
    data: data
  });
}

function updateByHeader(data) {
  return (0, _request.default)({
    url: 'api/CmsGenerateReport/updateByHeard',
    method: 'put',
    data: data
  });
}

function get(rowId) {
  return (0, _request.default)({
    url: 'api/CmsGenerateReport?rowId=' + rowId,
    method: 'get'
  });
}

function getReportData(data) {
  return (0, _request.default)({
    url: 'api/CmsGenerateReport/getReportData',
    method: 'get',
    data: data
  });
}

var _default = {
  add: add,
  edit: edit,
  del: del,
  updateByHeader: updateByHeader,
  getReportData: getReportData,
  get: get
};
exports.default = _default;